<template>
	<div id="app" ref="app">
		<router-view></router-view>
	</div>
</template>

<script>

	//import './assets/fonts/fonts.css';

	export default {
		name: 'app',
		teamcode: '',
		resp_id: '',
		challenge_token: '',
	}
</script>




// WEBPACK FOOTER //
// src/App.vue